export default __webpack_public_path__ + "static/media/22_1_3.5daf9e10.png";